import { AvatarsGenderId } from "../../utils";

export const scenesId = ["metahumans/gradient", "metahumans/tungsten", "metahumans/green"];

export const avatars = ["metahumans/andrey", "metahumans/nastya", "metahumans/irina", "metahumans/igor"];
export const avatarsGender: AvatarsGenderId[] = [
	{ id: "metahumans/andrey", gender: "male", name: "Андрей" },
	{ id: "metahumans/nastya", gender: "female", name: "Настя" },
	{ id: "metahumans/irina", gender: "female", name: "Ирина" },
	{ id: "metahumans/igor", gender: "male", name: "Игорь" },
];
